import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import { CHATBOT_PATH, CHATBOT_PUBLIC_PATH } from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';

const Chatbot = lazy(() => import('./pages/ChatbotPage'));

const ChatbotPublic = lazy(() => import('./pages/ChatbotPagePublic'));

export const CHATBOT_ROUTES = [
  {
    availableViews: [LayoutType.MOBILE],
    component: () => <Chatbot />,
    displayTitle: () => '',
    isNavHeaderHide: true,
    pageType: PageType.PRIVATE,
    path: CHATBOT_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.chatAssistant,
  },
  {
    availableViews: [LayoutType.MOBILE],
    component: () => <ChatbotPublic />,
    displayTitle: () => '',
    isNavHeaderHide: true,
    pageType: PageType.PUBLIC,
    path: CHATBOT_PUBLIC_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.publicChatAssistant,
  },
];
